import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import './admin-panel.css';

export default function ReviewBlogTab() {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [status, setStatus] = useState('loading'); // 'loading' | 'ready' | 'error'

  const load = () => {
    setStatus('loading');
    axios
      .get('/api/blogs/', { params: { status: 'review' } })
      .then((response) => {
        setBlogs(response.data?.blogs ?? []);
        setStatus('ready');
      })
      .catch(() => setStatus('error'));
  };

  useEffect(load, []);

  const handleApprove = async (blog) => {
    try {
      await axios.post(`/api/blogs/?id=${blog.id}&_method=PATCH`, { status: 'published' });
      toast.success(`"${blog.title}" published.`);
      load();
    } catch {
      toast.error('Could not publish the blog. Please try again.');
    }
  };

  const handleDelete = async (blog) => {
    if (!window.confirm(`Delete "${blog.title}"? This cannot be undone.`)) return;
    try {
      await axios.post(`/api/blogs/?id=${blog.id}&_method=DELETE`);
      toast.info('Blog deleted.');
      load();
    } catch {
      toast.error('Could not delete the blog. Please try again.');
    }
  };

  const handleEdit = (blog) => {
    navigate('/adminpanel/blogs/create', { state: { editId: blog.id } });
  };

  return (
    <div>
      <div className="admin-topbar">
        <div>
          <h1>Review Blogs</h1>
          <p>Verify title, content, category and cover image before publishing.</p>
        </div>
      </div>

      {status === 'loading' && (
        <div className="admin-panel admin-empty-state">
          <p>Loading…</p>
        </div>
      )}

      {status === 'error' && (
        <div className="admin-panel admin-empty-state">
          <p>Could not load blogs. Please try again later.</p>
        </div>
      )}

      {status === 'ready' && blogs.length === 0 && (
        <div className="admin-panel admin-empty-state">
          <i className="fa fa-inbox" />
          <p>No blogs waiting for review right now.</p>
        </div>
      )}

      {status === 'ready' &&
        blogs.map((blog) => (
          <div className="admin-review-card" key={blog.id}>
            <div className="admin-review-thumb-wrap">
              <img src={blog.image} alt={blog.title} className="admin-review-thumb" />
            </div>
            <div className="admin-review-body">
              <span className="admin-status-pill review">Pending Review</span>
              <h3 style={{ marginTop: 10 }}>{blog.title}</h3>
              <div className="admin-review-meta">
                <span>
                  <i className="fa fa-tag" />
                  {blog.category}
                </span>
              </div>
              <p className="admin-review-desc">{blog.excerpt}</p>
              <div className="admin-review-actions">
                <button
                  className="admin-btn admin-btn-outline admin-btn-sm"
                  onClick={() => handleEdit(blog)}
                >
                  <i className="fa fa-pen" /> Edit
                </button>
                <button
                  className="admin-btn admin-btn-success admin-btn-sm"
                  onClick={() => handleApprove(blog)}
                >
                  <i className="fa fa-check" /> Approve &amp; Publish
                </button>
                <button
                  className="admin-btn admin-btn-danger admin-btn-sm"
                  onClick={() => handleDelete(blog)}
                >
                  <i className="fa fa-trash" /> Delete
                </button>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}
